import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-okk",
  "use": "icon-okk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-okk\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024 518.322C1024 794.78 794.78 1024 505.678 1024 229.22 1024 0 794.78 0 518.322 0 229.22 229.22 0 505.678 0 794.78 0 1024 229.22 1024 518.322zM251.815 533.06l146.21 150.483a22.105 22.105 0 0 0 31.276 0.312l343.33-336.072a21.816 21.816 0 0 0-0.112-31.232l2.115 2.048c-8.771-8.593-23.664-9.35-33.124-1.514l-310.963 257.67c-9.572 7.947-25.065 8.125-34.86 0.667l-111.638-85.125a21.816 21.816 0 0 0-30.943 4.318l-3.495 4.742c-7.123 9.661-6.3 24.932 2.226 33.703z\" fill=\"#ff9700\" p-id=\"2148\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/okk.svg
// module id = eMcx
// module chunks = 81